<script setup lang="ts">
import { useFavoritesStore } from '@consumer/services/favorites/store'
import Favorites from './FavoritesMenu/Favorites.vue'
import FavoritesButton from './FavoritesMenu/FavoritesButton.vue'
import FavoriteToast from './FavoritesMenu/FavoriteToast.vue'
import AddedToListToast from './FavoritesMenu/AddedToListToast.vue'
import FlyOut from './FlyOut/FlyOut.vue'

const favorites = useFavoritesStore()

function onOpenChange (open: boolean) {
  if (open) favorites.loadRecentlyAddedFavorites()
}
</script>

<template>
  <FlyOut
    id="favorites-menu"
    :header="favorites.header"
    variant="list"
    @openChange="onOpenChange"
  >
    <template #trigger>
      <FavoritesButton/>
      <FavoriteToast class="lg:absolute lg:top-full lg:right-0 mt-3"/>
      <AddedToListToast class="lg:absolute lg:top-full lg:right-0 mt-3"/>
    </template>

    <template #content>
      <Favorites/>
    </template>
  </FlyOut>
</template>

<style lang="scss" scoped>
:deep(.list) {
  width: 400px;
}
</style>
